module.exports = __webpack_public_path__ + "static/media/iroll.f33d4628.png";